import Typography from '@/common/components/base/typography/Typography.tsx';
import { FC } from 'react';
import { Box, Flex } from 'styled-system/jsx';

type Props = { title: string };

const OnlyTitleHeader: FC<Props> = ({ title }) => {
  return (
    <Flex
      maxW="maxContainer"
      mx="auto"
      bgColor="white"
      shadow="headerShadow"
      height="66px"
      alignItems="center"
    >
      <Box w={'100%'}>
        <Typography textAlign="center" color="black-1">
          {title}
        </Typography>
      </Box>
    </Flex>
  );
};

export default OnlyTitleHeader;
